import request from '@/utils/request'

// 查询银行支行管理分页
export function pageBankBranch(data) {
  return request({
    url: '/bank/bank-branch/admin/page',
    method: 'post',
    data: data
  })
}

// 编辑银行支行
export function updateBankBranch(data) {
  return request({
    url: '/bank/bank-branch/admin/edit',
    method: 'post',
    data: data
  })
}

// 删除银行支行
export function delBankBranch(data) {
  return request({
    url: '/bank/bank-branch/admin/delete',
    method: 'post',
    data: data
  })
}

// 导出银行支行
export function exportBankBranch(data) {
  return request({
    url: '/bank/bank-branch/admin/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 查询省份名称下拉列表
export function listProvinceDict() {
  return request({
    url: '/bank/bank-branch/admin/provinceDict',
    method: 'post'
  })
}

// 查询银行图标下拉列表
export function listBankIconDict() {
  return request({
    url: '/bank/bank-branch/admin/bankIconDict',
    method: 'post'
  })
}